import _typeof from "@babel/runtime/helpers/esm/typeof";
import React from "react";
var SEG_SEP = ', ';
export function isPlainObject(value) {
  return _typeof(value) === 'object' && value !== null && ! /*#__PURE__*/React.isValidElement(value);
}
export function getElementProps(value) {
  if (! /*#__PURE__*/React.isValidElement(value)) {
    return {};
  }
  return value.props;
}
export function formatPageInfo(pageInfo, locale) {
  var sep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : SEG_SEP;
  var _pageInfo$current = pageInfo.current,
    current = _pageInfo$current === void 0 ? 1 : _pageInfo$current,
    _pageInfo$pageSize = pageInfo.pageSize,
    pageSize = _pageInfo$pageSize === void 0 ? 10 : _pageInfo$pageSize,
    _pageInfo$total = pageInfo.total,
    total = _pageInfo$total === void 0 ? 0 : _pageInfo$total;
  var startIndex = (current - 1) * pageSize;
  var endIndex = Math.min(current * pageSize, total);
  var length = endIndex - startIndex;
  var pageSeg = "".concat(locale.page, " ").concat(current);
  var index = length === 1 ? "".concat(endIndex) : "".concat(startIndex + 1, " - ").concat(endIndex);
  var template = total === 1 ? locale.ofItem : locale.ofItems;
  var rangeSeg = template.replace(/\$index/, "".concat(index)).replace(/\$total/, "".concat(total));
  return "".concat(pageSeg).concat(sep).concat(rangeSeg);
}